function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useRef } from "react";
import { Tabs, notification, Skeleton, List, Space, Modal, Tag, Button, DatePicker, Divider, Drawer, Input, Spin } from "antd";
import { PencilSquare, ListUl, GeoAltFill, CashCoin, WalletFill, Cart4, CashStack, HouseFill, Building, Plus, Cash, AwardFill, PeopleFill, PrinterFill, CheckCircleFill, CartCheckFill, XCircleFill, ClockHistory, Truck, PersonFill } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import SellToCustomer from "../components/forms/SellToCustomer";
import SportsModeIcon from '@iconify-react/flat-color-icons/sports-mode';
import moment from 'moment';
import Common from "../components/includes/Common";
import Moment from 'react-moment';
import AddPayout from "../components/forms/AddPayout";
import dayjs from 'dayjs';
import AddSettlement from "../components/forms/AddSettlement";
import { LoadingOutlined } from '@ant-design/icons';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import DisplayInvoice from "../components/DisplayInvoice";
import SettlementHistory from "../components/SettlementHistory";
import AddPo from "../components/forms/AddPo";
import EditCustomer from "../components/forms/EditCustomer";
import AddCustomer from "../components/forms/AddCustomer";
import Receipt from "../components/Receipt";
import AssignDeliveryPerson from "../components/forms/AssignDeliveryPerson";
import EditAssignDeliveryPerson from "../components/forms/EditAssignDeliveryPerson";
import AddPurchaseOrder from "../components/forms/AddPurchaseOrder";
import CustomerDetails from "../components/CustomerDetails";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Orders = function Orders() {
  var ref = useRef();
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    refresh = _useState2[0],
    setRefresh = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    orders = _useState4[0],
    setOrders = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    customers = _useState6[0],
    setCustomers = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    payouts = _useState8[0],
    setPayouts = _useState8[1];
  var _useState9 = useState(moment().startOf('week').format()),
    _useState0 = _slicedToArray(_useState9, 2),
    ordersFrom = _useState0[0],
    setOrdersFrom = _useState0[1];
  var _useState1 = useState(moment().endOf('week').format()),
    _useState10 = _slicedToArray(_useState1, 2),
    ordersTo = _useState10[0],
    setOrdersTo = _useState10[1];
  var _useState11 = useState(moment().startOf('week').format()),
    _useState12 = _slicedToArray(_useState11, 2),
    payoutsFrom = _useState12[0],
    setPayoutsFrom = _useState12[1];
  var _useState13 = useState(moment().endOf('week').format()),
    _useState14 = _slicedToArray(_useState13, 2),
    payoutsTo = _useState14[0],
    setPayoutsTo = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    ordersDataChanged = _useState16[0],
    setOrdersDataChanged = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    customersDataChanged = _useState18[0],
    setCustomersDataChanged = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    payoutsDataChanged = _useState20[0],
    setPayoutsDataChanged = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    ordersDataError = _useState22[0],
    setOrdersDataError = _useState22[1];
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    payoutsDataError = _useState24[0],
    setPayoutsDataError = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    customersDataError = _useState26[0],
    setCustomersDataError = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isOrdersLoading = _useState28[0],
    setIsOrdersLoading = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isCustomersLoading = _useState30[0],
    setIsCustomersLoading = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isPayoutsLoading = _useState32[0],
    setIsPayoutsLoading = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showAddPayout = _useState34[0],
    setShowAddPayout = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    showAddCustomer = _useState36[0],
    setShowAddCustomer = _useState36[1];
  var _useState37 = useState(''),
    _useState38 = _slicedToArray(_useState37, 2),
    customerKeyword = _useState38[0],
    setCustomerKeyword = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    showSettle = _useState40[0],
    setShowSettle = _useState40[1];
  var _useState41 = useState(null),
    _useState42 = _slicedToArray(_useState41, 2),
    selectedOrder = _useState42[0],
    setSelectedOrder = _useState42[1];
  var _useState43 = useState(0),
    _useState44 = _slicedToArray(_useState43, 2),
    userBalance = _useState44[0],
    setUserBalance = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    isBalanceLoading = _useState46[0],
    setIsBalanceLoading = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    showInvoice = _useState48[0],
    setShowInvoice = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    showSettlementHistory = _useState50[0],
    setShowSettlementHistory = _useState50[1];
  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    showCustomerDetails = _useState52[0],
    setShowCustomerDetails = _useState52[1];
  var _useState53 = useState(null),
    _useState54 = _slicedToArray(_useState53, 2),
    selectedCustomer = _useState54[0],
    setSelectedCustomer = _useState54[1];
  var _useState55 = useState(false),
    _useState56 = _slicedToArray(_useState55, 2),
    showAddPurchaseOrder = _useState56[0],
    setShowAddPurchaseOrder = _useState56[1];
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    showEditCustomer = _useState58[0],
    setShowEditCustomer = _useState58[1];
  var _useState59 = useState(false),
    _useState60 = _slicedToArray(_useState59, 2),
    isCancelLoading = _useState60[0],
    setIsCancelLoading = _useState60[1];
  var _useState61 = useState(false),
    _useState62 = _slicedToArray(_useState61, 2),
    showSell = _useState62[0],
    setShowSell = _useState62[1];
  var _useState63 = useState(false),
    _useState64 = _slicedToArray(_useState63, 2),
    showAssignDelivery = _useState64[0],
    setShowAssignDelivery = _useState64[1];
  var _useState65 = useState(false),
    _useState66 = _slicedToArray(_useState65, 2),
    showEditAssignDelivery = _useState66[0],
    setShowEditAssignDelivery = _useState66[1];
  var _useState67 = useState(null),
    _useState68 = _slicedToArray(_useState67, 2),
    userPos = _useState68[0],
    setUserPos = _useState68[1];
  var _useState69 = useState(false),
    _useState70 = _slicedToArray(_useState69, 2),
    showAddCompanyOrder = _useState70[0],
    setShowAddCompanyOrder = _useState70[1];
  var rangePresets = [{
    label: "Ajourdh'ui",
    value: [dayjs().startOf('day'), dayjs()]
  }, {
    label: "Cette semaine",
    value: [dayjs().startOf('week'), dayjs().endOf('week')]
  }, {
    label: 'Ce mois',
    value: [dayjs().startOf('month'), dayjs().endOf('month')]
  }];
  var pageTabItems = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Cart4, {
        size: 26
      }), " "]
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 7,
          children: /*#__PURE__*/_jsx(RangePicker, _defineProperty(_defineProperty(_defineProperty(_defineProperty({
            size: "medium",
            onChange: function onChange(dates, ds) {
              if (dates) {
                setOrdersFrom(dates[0].format());
                setOrdersTo(dates[1].format());
              }
            },
            format: "DD/MM/YYYY"
          }, "size", "large"), "allowClear", true), "needConfirm", false), "presets", rangePresets))
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("b", {
            children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
              date: ordersFrom,
              format: "DD/MM/YYYY"
            }), " au ", /*#__PURE__*/_jsx(Moment, {
              date: ordersTo,
              format: "DD/MM/YYYY"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(List, {
        loading: isOrdersLoading,
        itemLayout: "horizontal",
        dataSource: orders,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [/*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [item.status == Common.orderStatus.CONFIRMED_PAID && /*#__PURE__*/_jsx(Button, {
                type: "default",
                onClick: function onClick() {
                  setSelectedOrder(item);
                  setShowAssignDelivery(true);
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(SportsModeIcon, {
                    height: "17px"
                  }), " Ass. Livreur"]
                })
              }), item.status == Common.orderStatus.ASSIGNED && /*#__PURE__*/_jsx(Button, {
                icon: /*#__PURE__*/_jsx(PencilSquare, {}),
                type: "default",
                onClick: function onClick() {
                  setSelectedOrder(item);
                  setShowEditAssignDelivery(true);
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(SportsModeIcon, {
                    height: "17px"
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Button, {
              type: "default",
              onClick: function onClick() {
                setSelectedOrder(item);
                setShowInvoice(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(PrinterFill, {
                  size: 18
                })
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "default",
              disabled: moment().diff(moment(item.created_at), "hours") > 24 || item.status == Common.orderStatus.CANCELLED,
              onClick: function onClick() {
                setSelectedOrder(item);
                handleCancel(item);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(XCircleFill, {
                  color: "#DC6847"
                }), " Annuler"]
              })
            })],
            children: /*#__PURE__*/_jsx(Skeleton, {
              avatar: true,
              title: false,
              loading: isOrdersLoading,
              active: true,
              children: /*#__PURE__*/_jsx(List.Item.Meta, {
                title: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsxs("div", {
                    children: [item.status == 0 && /*#__PURE__*/_jsx(ClockHistory, {
                      style: {
                        color: '#ED8042'
                      },
                      size: 20
                    }), "     ", item.status == 1 && /*#__PURE__*/_jsx(CheckCircleFill, {
                      style: {
                        color: '#85D58C'
                      },
                      size: 20
                    }), "  ", item.status == 2 && /*#__PURE__*/_jsx(SportsModeIcon, {
                      height: "28px"
                    }), "                             ", item.status == 3 && /*#__PURE__*/_jsx(Truck, {
                      style: {
                        color: '#0C4AA6'
                      },
                      size: 20
                    }), "            ", item.status == 4 && /*#__PURE__*/_jsx(AwardFill, {
                      style: {
                        color: '#0C4AA6'
                      },
                      size: 20
                    }), "        ", item.status == 5 && /*#__PURE__*/_jsx(XCircleFill, {
                      style: {
                        color: '#ae473e'
                      },
                      size: 20
                    }), "        "]
                  }), /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: item.created_at,
                      format: "DD/MM/YYYY HH:mm"
                    })
                  }), /*#__PURE__*/_jsx(Tag, {
                    color: "#f50",
                    children: item.provider && item.provider.label
                  })]
                }),
                description: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Cash, {
                    color: "#D6423F",
                    size: 20
                  }), " ", /*#__PURE__*/_jsx("span", {
                    style: {
                      fontWeight: "bold",
                      color: "#D6423F"
                    },
                    children: item.total_amount.toLocaleString("Fr") + " GnF "
                  }), " ", item.customer.type == 0 ? /*#__PURE__*/_jsx(PersonFill, {
                    size: 20
                  }) : /*#__PURE__*/_jsx(HouseFill, {
                    size: 20
                  }), " ", item.customer.mobile.slice(3)]
                })
              })
            })
          });
        }
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(HouseFill, {
        size: 24
      }), " "]
    }),
    key: 2,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 7,
          children: /*#__PURE__*/_jsx(Input, {
            size: "large",
            placeholder: "Chercher un client",
            onChange: function onChange(e) {
              setCustomerKeyword(e.target.value);
            }
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Button, {
            size: "large",
            type: "default",
            icon: /*#__PURE__*/_jsx(Plus, {}),
            onClick: function onClick() {
              setShowAddCustomer(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "Nouveau client"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(List, {
        loading: isCustomersLoading,
        itemLayout: "horizontal",
        dataSource: customers,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [/*#__PURE__*/_jsxs(Button, {
              onClick: function onClick() {
                setSelectedCustomer(item);
                setShowAddCompanyOrder(true);
              },
              children: [/*#__PURE__*/_jsx(Cart4, {
                size: 24
              }), " ", /*#__PURE__*/_jsx("b", {
                children: "NOUVELLE COMMANDE"
              })]
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                setSelectedCustomer(item);
                setShowCustomerDetails(true);
              },
              children: /*#__PURE__*/_jsx(ListUl, {
                size: 22
              })
            }), /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                setSelectedCustomer(item);
                setShowEditCustomer(true);
              },
              children: /*#__PURE__*/_jsx(PencilSquare, {
                size: 22
              })
            }), /*#__PURE__*/_jsx(Button, {
              href: "https://www.google.com/maps?q=" + item.geocode,
              target: "_blank",
              children: /*#__PURE__*/_jsx(GeoAltFill, {
                size: 22
              })
            })],
            children: /*#__PURE__*/_jsx(Skeleton, {
              avatar: true,
              title: false,
              loading: isOrdersLoading,
              active: true,
              children: /*#__PURE__*/_jsx(List.Item.Meta, {
                title: /*#__PURE__*/_jsx("b", {
                  children: item.name
                }),
                description: "Tel : " + item.mobile
              })
            })
          });
        }
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CashStack, {
        size: 24
      }), " "]
    }),
    key: 4,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 7,
          children: /*#__PURE__*/_jsx(RangePicker, {
            size: "large",
            onChange: function onChange(dates, ds) {
              if (dates) {
                setPayoutsFrom(dates[0].format());
                setPayoutsTo(dates[1].format());
              }
            },
            format: "DD/MM/YYYY",
            allowClear: true,
            needConfirm: false,
            presets: rangePresets
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Button, {
            size: "large",
            type: "default",
            icon: /*#__PURE__*/_jsx(CashCoin, {}),
            onClick: function onClick() {
              setShowAddPayout(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "Faire un versement"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("b", {
            children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
              date: payoutsFrom,
              format: "DD/MM/YYYY"
            }), " au ", /*#__PURE__*/_jsx(Moment, {
              date: payoutsTo,
              format: "DD/MM/YYYY"
            })]
          })
        })
      }), /*#__PURE__*/_jsx(List, {
        loading: isPayoutsLoading,
        itemLayout: "horizontal",
        dataSource: payouts,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [],
            children: /*#__PURE__*/_jsx(Skeleton, {
              avatar: true,
              title: false,
              loading: isPayoutsLoading,
              active: true,
              children: /*#__PURE__*/_jsx(List.Item.Meta, {
                title: /*#__PURE__*/_jsxs(Space, {
                  children: [/*#__PURE__*/_jsx("div", {
                    children: item.status == 0 ? /*#__PURE__*/_jsx(ClockHistory, {
                      color: "#B1624B",
                      size: 20
                    }) : /*#__PURE__*/_jsx(CheckCircleFill, {
                      color: "#407A56",
                      size: 20
                    })
                  }), /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: item.created_at,
                      format: "DD/MM/YYYY HH:mm"
                    })
                  })]
                }),
                description: /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx(CashCoin, {
                    color: "#B1624B",
                    size: 20
                  }), " ", item.amount.toLocaleString("Fr"), " GNF  ", item.approver && "Agent Approbateur: " + item.approver.prenom + " " + item.approver.nom]
                })
              })
            })
          });
        }
      })]
    })
  }];
  var handleCancel = function handleCancel(item) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      type: "warning",
      content: /*#__PURE__*/_jsxs("b", {
        children: ["L'annulation de la vente pour ", item.total_amount.toLocaleString("Fr")]
      }),
      onOk: function onOk() {
        setIsCancelLoading(true);
        axios.post(Common.baseApiUrl + "abortorder", {
          user_id: Common.currentUser.id,
          purchase_order_id: item.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setOrdersDataChanged(true);
            setRefresh(true);
          } else notification.error({
            message: "Erreur !",
            description: response.data.message
          });
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue "
          });
        })["finally"](function () {
          setIsCancelLoading(false);
        });
      },
      onCancel: function onCancel() {}
    });
  };
  useEffect(function () {
    setRefresh(false);
    setCustomersDataChanged(false);
    setIsCustomersLoading(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getcompanies/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      } else {
        setCustomersDataError(response[0].data.message);
      }
    })["finally"](function () {
      setIsCustomersLoading(false);
    });
  }, [refresh, customersDataChanged, customerKeyword]);
  useEffect(function () {
    setRefresh(false);
    setPayoutsDataChanged(false);
    setOrdersDataChanged(false);
    setIsOrdersLoading(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getperiodicorders/").concat(Common.currentUser.id, "/").concat(ordersFrom, "/").concat(ordersTo))]).then(function (response) {
      if (response[0].data.status == 200) {
        setOrders([]);
        setOrders(response[0].data.orders);
      } else {
        setOrdersDataError(response[0].data.message);
      }
    })["finally"](function () {
      setIsOrdersLoading(false);
    });
  }, [refresh, ordersDataChanged, ordersFrom, ordersTo]);
  useEffect(function () {
    setRefresh(false);
    setPayoutsDataChanged(false);
    ;
    setIsOrdersLoading(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getuserdeposits/").concat(Common.currentUser.id, "/").concat(payoutsFrom, "/").concat(payoutsTo))]).then(function (response) {
      if (response[0].data.status == 200) {
        setPayouts(response[0].data.deposits);
      } else {
        setPayoutsDataError(response[0].data.message);
      }
    })["finally"](function () {
      setPayoutsDataChanged(false);
    });
  }, [refresh, payoutsDataChanged, payoutsFrom, payoutsTo]);
  useEffect(function () {
    setIsBalanceLoading(true);
    setOrdersDataChanged(true);
    axios.all([axios.get("".concat(Common.baseApiUrl, "getuserpointofsale/").concat(Common.currentUser.id))]).then(function (response) {
      if (response[0].data.status == 200) {
        setUserPos(response[0].data.pointOfSale);
      }
    })["finally"](function () {
      setIsBalanceLoading(false);
    });
  }, [refresh, payoutsDataChanged, ordersDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [ContextHolder, /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 5,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              padding: "12px",
              background: "#EC9A68",
              borderRadius: "12px",
              marginTop: "12px"
            },
            children: /*#__PURE__*/_jsx(SellToCustomer, {
              handler: function handler() {
                setShowSell('false');
                setRefresh(true);
                notification.success({
                  message: "Ok!",
                  description: "Vente éffectuée"
                });
              }
            })
          })
        }), /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              background: "#FFF",
              padding: "8px",
              borderRadius: "8px",
              margin: "8px 0px"
            },
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [!isBalanceLoading && userPos ? /*#__PURE__*/_jsxs("h5", {
                style: {
                  color: "#D66625"
                },
                children: [/*#__PURE__*/_jsx(CashCoin, {
                  size: 16
                }), " ", userPos.balance.toLocaleString("Fr"), " GnF"]
              }) : /*#__PURE__*/_jsx(Spin, {
                styles: {
                  indicator: {
                    color: "#E9E4E4"
                  }
                },
                indicator: /*#__PURE__*/_jsx(LoadingOutlined, {
                  spin: true
                })
              }), userPos && /*#__PURE__*/_jsx(Tag, {
                color: "default",
                children: userPos.label
              })]
            })
          }), /*#__PURE__*/_jsx(Tabs, {
            items: pageTabItems,
            animated: true
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CashCoin, {
          size: 18
        }), " INITIER UN VERSEMENT"]
      }),
      width: {
        xs: '95%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '50%'
      },
      open: showAddPayout,
      footer: null,
      onCancel: function onCancel() {
        setShowAddPayout(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(AddPayout, {
        operationType: 0,
        handler: function handler() {
          setPayoutsDataChanged(true);
          setShowAddPayout(false);
          notification.success({
            message: "Ok!",
            description: "Opération réussie !"
          });
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Ajouter un nouveau client"
      }),
      width: {
        xs: '95%',
        sm: '80%',
        md: '50%',
        lg: '50%',
        xl: '40%',
        xxl: '30%'
      },
      open: showAddCustomer,
      footer: null,
      onCancel: function onCancel() {
        setShowAddCustomer(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx("div", {
        style: {
          padding: "16px"
        },
        children: /*#__PURE__*/_jsx(AddCustomer, {
          handler: function handler() {
            setShowAddCustomer(false);
            setCustomersDataChanged(true);
            notification.success({
              message: "Ok",
              description: "Opération réussie"
            });
          }
        })
      })
    }), selectedOrder && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "R\xE9gler la facture"
        }),
        open: showSettle,
        onCancel: function onCancel() {
          setShowSettle(false);
        },
        destroyOnClose: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(AddSettlement, {
          bill: selectedOrder,
          handler: function handler() {
            setOrdersDataChanged(true);
            setCustomersDataChanged(true);
            setShowSettle(false);
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS COMMANDE"
        }),
        width: "395px",
        open: showInvoice,
        onClose: function onClose() {
          setShowInvoice(false);
        },
        destroyOnClose: true,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref) {
                var handlePrint = _ref.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  onClick: handlePrint,
                  type: "ghost",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "IMPRIMER"
                  })
                });
              }
            })
          })
        }),
        children: /*#__PURE__*/_jsx(Receipt, {
          ref: ref,
          order: selectedOrder
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Historique des paiements"
        }),
        open: showSettlementHistory,
        onCancel: function onCancel() {
          setShowSettlementHistory(false);
        },
        destroyOnClose: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(SettlementHistory, {
          bill: selectedOrder,
          handler: function handler() {
            setOrdersDataChanged(true);
            setShowSettlementHistory(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(SportsModeIcon, {
            height: "17px"
          }), " Assigner un livreur"]
        }),
        open: showAssignDelivery,
        onCancel: function onCancel() {
          setShowAssignDelivery(false);
        },
        destroyOnClose: true,
        centered: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '70%',
          md: '40%',
          lg: '40%',
          xl: '40%',
          xxl: '30%'
        },
        children: /*#__PURE__*/_jsx(AssignDeliveryPerson, {
          order: selectedOrder,
          handler: function handler() {
            setOrdersDataChanged(true);
            setShowAssignDelivery(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(SportsModeIcon, {
            height: "17px"
          }), " Changer de livreur"]
        }),
        open: showEditAssignDelivery,
        onCancel: function onCancel() {
          setShowEditAssignDelivery(false);
        },
        destroyOnClose: true,
        centered: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '70%',
          md: '40%',
          lg: '40%',
          xl: '40%',
          xxl: '30%'
        },
        children: /*#__PURE__*/_jsx(EditAssignDeliveryPerson, {
          order: selectedOrder,
          handler: function handler() {
            setOrdersDataChanged(true);
            setRefresh(true);
            setShowEditAssignDelivery(false);
          }
        })
      })]
    }), selectedCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Modifier les infos du client"
        }),
        open: showEditCustomer,
        onCancel: function onCancel() {
          setShowEditCustomer(false);
        },
        destroyOnClose: true,
        footer: null,
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(EditCustomer, {
          customer: selectedCustomer,
          handler: function handler() {
            setCustomersDataChanged(true);
            setShowEditCustomer(false);
            notification.success({
              message: "Ok!",
              description: "Opération réussie !"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS CLIENT"
        }),
        open: showCustomerDetails,
        onClose: function onClose() {
          setShowCustomerDetails(false);
        },
        destroyOnClose: true,
        footer: null,
        width: "85%",
        children: /*#__PURE__*/_jsx(CustomerDetails, {
          customer_id: selectedCustomer.id,
          handler: function handler() {
            setCustomersDataChanged(true);
            setShowCustomerDetails(false);
            notification.success({
              message: "Ok!",
              description: "Opération réussie !"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Nouvelle commande entreprise"
        }),
        open: showAddCompanyOrder,
        onClose: function onClose() {
          setShowAddCompanyOrder(false);
        },
        destroyOnClose: true,
        width: "420px",
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "12px",
            background: "#ABCAEC",
            borderRadius: "12px"
          },
          children: /*#__PURE__*/_jsx(SellToCustomer, {
            customer: selectedCustomer,
            handler: function handler() {
              setCustomersDataChanged(true);
              setShowAddCompanyOrder(false);
              notification.success({
                message: "Ok!",
                description: "Opération réussie !"
              });
            }
          })
        })
      })]
    })]
  });
};
export default Orders;